import { Link } from "react-router-dom";
import { useI18n } from "@/lib/i18n";
import LanguageSwitcher from "@/components/LanguageSwitcher";

export default function PrivacyPage() {
  const { t } = useI18n();
  return (
    <div className="min-h-screen bg-white" data-testid="privacy-page">
      <header className="border-b border-slate-100 bg-white/90 backdrop-blur-lg sticky top-0 z-50">
        <div className="max-w-4xl mx-auto px-4 h-14 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2"><img src="/logo.jpg" alt="Smartpriced" className="h-8" /></Link>
          <LanguageSwitcher />
        </div>
      </header>
      <main className="max-w-4xl mx-auto px-4 py-16">
        <h1 className="text-3xl font-black text-slate-900 mb-2">{t("privacy.title")}</h1>
        <p className="text-sm text-slate-500 mb-10">Laatst bijgewerkt: Februari 2026</p>
        <div className="prose prose-slate prose-sm max-w-none [&_h3]:text-lg [&_h3]:font-bold [&_h3]:mt-10 [&_h3]:mb-3 [&_p]:leading-relaxed">

          <h3>1. {t("privacy.data_title").split("?")[0].replace(/^\d+\.\s*/, "").replace("Welke gegevens verzamelen wij", t("privacy.data_title").split("?")[0])}?</h3>
          <p>{t("privacy.intro")}</p>

          <h3>2. {t("privacy.data_title")}</h3>
          <ul>
            <li>{t("privacy.data_account")}</li>
            <li>{t("privacy.data_payment")}</li>
            <li>{t("privacy.data_usage")}</li>
            <li>{t("privacy.data_product")}</li>
            <li>{t("privacy.data_communication")}</li>
          </ul>

          <h3>3. {t("privacy.purpose_title")}</h3>
          <ul>
            <li>{t("privacy.purpose_account")}</li>
            <li>{t("privacy.purpose_billing")}</li>
            <li>{t("privacy.purpose_support")}</li>
            <li>{t("privacy.purpose_improve")}</li>
          </ul>

          <h3>4. {t("privacy.cookies_title")}</h3>
          <ul>
            <li>{t("privacy.cookie_essential")}</li>
            <li>{t("privacy.cookie_analytics")}</li>
          </ul>

          <h3>5. {t("privacy.retention_title")}</h3>
          <ul>
            <li>{t("privacy.retention_account")}</li>
            <li>{t("privacy.retention_billing")}</li>
            <li>{t("privacy.retention_logs")}</li>
          </ul>

          <h3>6. {t("privacy.rights_title")}</h3>
          <ul>
            <li>{t("privacy.right_access")}</li>
            <li>{t("privacy.right_rectification")}</li>
            <li>{t("privacy.right_erasure")}</li>
            <li>{t("privacy.right_portability")}</li>
          </ul>

        </div>
      </main>
    </div>
  );
}
